import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Sun, Leaf, Heart } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <Moon className="w-10 h-10" data-id="element-1" />,
    title: 'Concilia el sueño en 15 minutos',
    desc: 'Sin dar vueltas por horas mirando el techo. Aprende a apagar el interruptor mental.'
  }, {
    icon: <Sun className="w-10 h-10" data-id="element-2" />,
    title: 'Despierta con Claridad',
    desc: "Adiós a la 'neblina mental' matutina. Levántate sintiéndote renovada y lúcida."
  }, {
    icon: <Leaf className="w-10 h-10" data-id="element-3" />,
    title: 'Libertad Natural',
    desc: 'Reduce tu dependencia de ayudas artificiales y químicos que dañan tu cuerpo.'
  }, {
    icon: <Heart className="w-10 h-10" data-id="element-4" />,
    title: 'Energía Vital',
    desc: 'Recupera las ganas de vivir tu día al máximo y disfrutar de tu familia.'
  }];
  return <section className="bg-slate-900 py-24 px-4" data-id="element-5">
      <div className="max-w-6xl mx-auto" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-7">
          <h2 className="text-3xl md:text-5xl font-bold text-amber-50 mb-6 font-serif" data-id="element-8">
            Lo que recuperarás
          </h2>
          <p className="text-xl text-slate-400" data-id="element-9">
            Más que dormir, se trata de volver a vivir.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-10">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-800 p-8 rounded-2xl border border-slate-700 hover:border-amber-500/40 transition-all group" data-id="element-11">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-12">
                <div className="bg-amber-500/10 p-4 rounded-full text-amber-400 group-hover:bg-amber-500 group-hover:text-slate-900 transition-colors duration-300" data-id="element-13">
                  {benefit.icon}
                </div>
                <div data-id="element-14">
                  <h3 className="text-2xl font-bold text-slate-100 mb-2" data-id="element-15">
                    {benefit.title}
                  </h3>
                  <p className="text-slate-300 text-lg leading-relaxed" data-id="element-16">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}